import { render } from "./ModalLoginDev.vue?vue&type=template&id=08753a6e"
import script from "./ModalLoginDev.vue?vue&type=script&lang=js"
export * from "./ModalLoginDev.vue?vue&type=script&lang=js"

import "./ModalLoginDev.vue?vue&type=style&index=0&id=08753a6e&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__